import * as yup from 'yup';

export const RequiredString = () => yup.string().required('required');

export const RequiredFile = () => yup.mixed().required('required');

export const String = () => yup.string();
